export const VERIFIED_ASSESSMENT = 'BA_VERIFIED_ASSESSMENT';
export const SPORTS_PERSONALITY_QUESTIONAIRE = 'BA_SPORTS_PERSONALITY_QUESTIONAIRE';

export const COMPARATIVE_DATA_ADDON = 'BA_COMPARATIVE_DATA_ADDON';
export const VIDEO_HOURS_1_ADDON = 'BA_VIDEO_HOURS_1_ADDON';
export const VIDEO_HOURS_5_ADDON = 'BA_VIDEO_HOURS_5_ADDON';
export const SCHOOL_SEARCH_ADDON = 'BA_SCHOOL_SEARCH_ADDON';